import { IsNotEmpty, IsNumber, IsIn, IsOptional, IsBoolean } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IDockJumpingScore } from "./dock-jumping-score.interface";

export class DockJumpingScoreDto implements IDockJumpingScore {
  //
  /**
   * Constants.score_result_type:
   * Qualified
   * NQ
   */
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsNotEmpty()
  @IsNumber()
  feet: number;

  @IsNotEmpty()
  @IsNumber()
  inches: number;

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
